export const imgUrl = import.meta.env.VITE_IMAGE_URL;
export const url = 'http://localhost:5000';
export const editorUrl = import.meta.env.VITE_ADSIGN_EDITOR_URL;
